import { createAsyncThunk } from "@reduxjs/toolkit"; 
import { getAllCountries } from "../../Api/countries";

export const fetchCountriesData = createAsyncThunk(
  "countries/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getAllCountries(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);